export const Settings = {
	cookieName: 'on-air',
	cookieExpiry: 365,

	defaultMetaTitle: 'On Air',
	defaultMetaDescription: 'On Air Presents is a hybrid creative studio and events company operating at the intersection of sound, story, and spectacle.',
	defaultMetaImage: '/opengraph/opengraph-image.jpg',

	storiesPrefix: 'explore',
	eventsPrefix: 'events',
	projectsPrefix: 'projects',
	sessionsPrefix: 'session',

	sameSiteHosts: [
		'onairpresents.com',
		'www.onairpresents.com',
		'onairfestival.com',
		'www.onairfestival.com',
		'onairfest.com',
		'www.onairfest.com',
	],

	storyTypes: {
		'All': 'All',
		'News': 'News',
		'Video': 'Videos',
		'Photo Gallery': 'Galleries',
		'Article': 'Articles',
		'On Air Fest': 'On Air Fest',
		// 'Creator': 'Creators',
		// 'Event': 'Events',
		// 'Podcast': 'Podcasts',
	},

	highlightsTypes: {
		'All': 'All',
		'podcast': 'Podcast',
		'photo-gallery': 'Photo Gallery',
		'video': 'Video'
	},

	projectTypes: {
		'All': 'All',
		'Branding': 'Branding',
		'Campaign': 'Campaigns',
		'Design': 'Design',
		'Event': 'Events',
		'Podcast': 'Podcasts',
		'Social Media': 'Social Media',
		'Video': 'Videos'
	}
};
